export const ACTION_LIST_CLIENTS = "ACTION_LIST_CLIENTS";
export const ACTION_DETAIL_CLIENT = "ACTION_DETAIL_CLIENT";
export const ACTION_UPDATE_CLIENT = "ACTION_UPDATE_CLIENT";
export const ACTION_DIALOG_ACTIVE = "ACTION_DIALOG_ACTIVE";